import { z } from 'zod';
import { phoneNumberField } from '@shared/schemas';
import { tradeSchema } from './ITrade';

// Schemas (source of truth) — pure validation, no transforms
export const baseManagerSchema = tradeSchema.extend({
	projectId: z.string(),
	organizationId: z.string(),
	name: z.string(),
	phoneNumber: phoneNumberField,
	receiveNotifications: z.boolean().optional(),
});

// Types (derived from schemas)
export type IBaseManager = z.infer<typeof baseManagerSchema>;
